const gcd = (width, height) => {
  return height === 0 ? width : gcd(height, width % height);
};

// izracunavanje aspect ratio ekrana za skaliranje
// za sad je 16 / 9 hardkodirano
const height = window.screen.height;
const width = window.screen.width;
const ratio = gcd(width, height);
const heightRatio = height / ratio;
const widthRatio = width / ratio;

const aspectRatioScreen = {
  widthScale: 16,
  heightScale: 9,
};
const aspectRatio = 16 / 9;
let onloadScale;

export const resize = (width, height, setState) => {
  const mainContainer = document.querySelector(".admin-panel");
  if (mainContainer !== null) {
    let gameHeight, gameWidth;
    onloadScale = width / height;
    if (width > height) {
      if (onloadScale > aspectRatio) {
        gameHeight = height;
        gameWidth =
          (gameHeight * aspectRatioScreen.widthScale) /
          aspectRatioScreen.heightScale;
      } else {
        gameWidth = width;
        gameHeight =
          (gameWidth * aspectRatioScreen.heightScale) /
          aspectRatioScreen.widthScale;
      }
    } else {
      if (onloadScale > 1 / aspectRatio) {
        gameHeight = window.outerHeight;
        gameWidth =
          (gameHeight * aspectRatioScreen.heightScale) /
          aspectRatioScreen.widthScale;
      } else {
        gameWidth = window.outerWidth;
        gameHeight =
          (gameWidth * aspectRatioScreen.widthScale) /
          aspectRatioScreen.heightScale;
      }
    }
    // mainContainer.style.width = gameWidth + "px";
    // mainContainer.style.height = gameHeight + "px";
    mainContainer.style.width = 100 + "vw";
    mainContainer.style.height = 100 + "vh";
    setState(true);
  }
};
